import React, { Component } from 'react';
import MyReview from './MyReview';

export class MyReviewList extends Component {
  render() {
    let numb = 0;
    return this.props.reviews.map(review => (
      <MyReview
        key={numb++}
        reviewLoc={review}
        deleteReviewFromUser={this.props.deleteReviewFromUser}
        incrementSofties={this.props.incrementSofties}
      />
    ));
  }
}

export default MyReviewList;
